export default "__VITE_ASSET__CyVfL0GI__"